import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import Layout from "@/layout";

export const constantRouterMap = [
  { path: "/", component: () => import("@/login"),name:'login' },
  { path: "/login", component: () => import("@/login"),name:'login' },
  {
    path: "/layout",
    component: Layout,
    name: "Layout",
    children: [
      {
        path: "/home",
        name: "Home",
        component: () => import("@/page/home/index.vue"),
        meta: {
          hasFooter: true,
          title: "智慧市政 温馨家园"
        }
      },
      {
        path: "/monitor",
        name: "monitor",
        component: () => import("@/page/monitor/index.vue")
      },
      {
        path: "/illegal/",
        name: "Illegal",
        component: () => import("@/page/illegal/index.vue"),
        meta: {
          title: "非法占挖掘",
          hasFooter: true
        }
      },
      {
        path: "/maintenance",
        name: "Maintenance",
        component: () => import("@/page/maintenance/index.vue"),
        meta: {
          title: "占挖掘",
          hasFooter: true
        }
      },
      {
        path: "/check",
        name: "Check",
        component: () => import("@/page/check"),
        meta: {
          title: "设施查看",
          hasFooter: true,
        }
      },
      {
        path: "/inspect",
        name: "Inspect",
        component: () => import("@/page/inspect"),
        meta: {
          title: "巡更",
          hasFooter: true
        }
      },
      {
        path: "/inspect/subpage/task",
        name: "task",
        component: () => import("@/page/inspect/subpage/task"),
        meta: {
          title: "今日任务",
          hasBack:true,
          backPath:'/inspect'
        }
      },
      {
        path: "/inspect/subpage/Grievance",
        name: "grievance",
        component: () => import("@/page/inspect/subpage/grievance"),
        meta: {
          title: "巡更申诉",
          hasBack:true,
          backPath:'/inspect'
        }
      },
      // 巡更再次申诉
      
      {
        path: "/inspect/subpage/againAppeal/:id",
        name: "againAppeal",
        component: () => import("@/page/inspect/subpage/againAppeal"),
        meta: {
          title: "申诉",
          hasBack:true,
        }
      },
      {
        path: "/inspect/subpage/petrolhistory",
        name: "petrolhistory",
        component: () => import("@/page/inspect/subpage/petrolhistory"),
        meta: {
          title: "按照日期查找",
          hasBack:true,
          backPath:'/inspect'
        }
      },
      // 具体日期查记录
      {
        path: "/inspect/subpage/dayHistory/:time",
        name: "dayHistory",
        component: () => import("@/page/inspect/subpage/dayHistory"),
        meta: {
          title: "",
          hasBack:true,
          backPath:'/inspect/subpage/petrolhistory'
        }
      },
      // 批量申诉
      {
        path: "/inspect/subpage/batchgrievance/:time",
        name: "batchgrievance",
        component: () => import("@/page/inspect/subpage/batchgrievance"),
        meta: {
          title: "",
          hasBack:true,
        }
      },
      // 巡更历史详情
      {
        path: "/inspect/subpage/historyDetail",
        name: "historyDetail",
        component: () => import("@/page/inspect/subpage/historyDetail"),
        meta: {
          title: "",
          hasBack:true,

        }
      },

      {
        path: "/inspect/subpage/grievancecontent/:time",
        name: "grievancecontent",
        component: () => import("@/page/inspect/subpage/grievancecontent"),
        meta: {
          title: "",
          hasBack:true,
          backPath:'/inspect/subpage/Grievance'
        }
      },
      // {
      //   path: "/inspect/history",
      //   name: "inspectHistory",
      //   component: () => import("@/page/inspect/subpage/history"),
      //   meta: {
      //     title: "巡更记录",
      //     hasFooter: true,
      //   }
      // },
      {
        path: "/inspect/report/:id",
        name: "inspectReport",
        component: () => import("@/page/inspect/subpage/report"),
        meta: {
          title: "巡更",
          hasBack:true,
        }
      },
      {
        path: "/inspect/position",
        name: "InspectPosition",
        component: () => import("@/page/inspect/subpage/position"),
        meta: {
          title: "巡更点位置",
          hasBack: true
        }
      },
      {
        path: "/check/detail",
        name: "CheckDetail",
        component: () => import("@/page/check/subpage/detail"),
        meta: {
          hasMore: true,
          hasBack:true,
          backPath:'/check'
        }
      },
      {
        path: "/check/edit",
        name: "checkEdit",
        component: () => import("@/page/check/subpage/edit"),
        meta: {
          title: "编辑"
        }
      },
      {
        path: "/collect",
        name: "Collect",
        component: () => import("@/page/collect"),
        meta: {
          title: "设施采集",
          hasFooter: true,
        }
      },
      {
        path: "/collect/detail",
        name: "CollectDetail",
        component: () => import("@/page/collect/subpage/detail"),
        meta: {
          hasMore: true,
          hasBack:true,
          backPath:'/collect'
        }
      },
      {
        path: "/collect/edit",
        name: "collectEdit",
        component: () => import("@/page/collect/subpage/edit"),
        meta: {
          title: "编辑"
        }
      },
      {
        path: "/collect/add",
        name: "collectAdd",
        component: () => import("@/page/collect/subpage/add"),
        meta: {
          title: "添加"
        }
      },
      {
        path: "/map",
        name: "map",
        component: () => import("@/page/map")
      },
      {
        path: "/mine",
        name: "mine",
        component: () => import("@/page/mine"),
        meta: {
          title: "我的",
          hasFooter: true
        }
      },
      {
        path: "/clockIn",
        name: "clockIn",
        component: () => import("@/page/clockIn"),
        meta: {
          title: "公厕巡检",
          hasFooter: false
        }
      },
      {
        path: "/hygienism",
        name: "hygienism",
        component: () => import("@/page/hygienism"),
        meta: {
          title: "卫情上报",
          hasFooter: true
        }
      },
      {
        path: "/issue",
        name: "issue",
        component: () => import("@/page/issue"),
        meta: {
          title: "督查检查",
          hasFooter: true
        }
      },
      {
        path: "/issue/add",
        name: "issudAdd",
        component: () => import("@/page/issue/subpage/add"),
        meta: {
          title: "上报",
          hasBack:true,
          backPath:'/issue'
        }
      },
      {
        path: "/issue/detail/:id/:distance",
        name: "issueDetail",
        component: () => import("@/page/issue/subpage/detail"),
        meta: {
          title: "详情",
          hasBack:true,
        }
      },
      {
        path: "/issue/detailOfFinishedIssue/:id",
        name: "detailOfFinishedIssue",
        component: () => import("@/page/issue/subpage/detailOfFinishedIssue"),
        meta: {
          title: "详情",
          hasBack:true,
        }
      },
      {
        path: "/issue/subpage/manageDetail/:id",
        name: "manageDetail",
        component: () => import("@/page/issue/subpage/manageDetail"),
        meta: {
          title: "处理",
          hasBack:true,
        }
      },
      {
        path: "/issue/detailOfFinishedIssue",
        name: "issudDetailOfFinishedIssue",
        component: () => import("@/page/issue/subpage/detailOfFinishedIssue"),
        meta: {
          title: "详情"
        }
      },

      {
        path: "/issue/detailItem",
        name: "detailItem",
        component: () => import("../components/detailItem.vue"),
        meta: {
          title: "处理",
          hasBack:true,
        }
      }
    ]
  }
];

export default new Router({
  // mode:'history',
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js